var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.loading)?_c('v-row',{staticClass:"my-5",attrs:{"align":"center","justify":"center"}},[(_vm.loading)?_c('v-progress-circular',{staticClass:"p-4",attrs:{"indeterminate":"","color":"primary"}}):_vm._e()],1):_vm._e(),(!_vm.loading)?_c('section',{domProps:{"innerHTML":_vm._s(_vm.conditions)}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }